import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";

export function Modal({ children, openModal = false, closeModal = () => null, className = "max-w-7xl rounded-md", classNameActivate = "" }) {
    return (
        <Transition appear show={openModal} as={Fragment}>
            <Dialog as="div" className="fixed inset-0 z-100 overflow-y-auto pl-[5.2rem]" onClose={closeModal}>
                <div className="min-h-screen px-4 text-center">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0">
                        <Dialog.Overlay className="fixed inset-0" />
                    </Transition.Child>

                    {/* This element is to trick the browser into centering the modal contents. */}
                    <span className="inline-block h-screen align-middle" aria-hidden="true">
                        &#8203;
                    </span>
                    <Dialog.Overlay className="fixed inset-0 bg-gray-400 bg-opacity-50" />
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95">
                        <section
                            className={`relative inline-block transform overflow-hidden bg-white text-left align-middle text-gray-400 shadow-[0px_4px_4px_rgba(0,_0,_0,_0.25)] transition-all ${className} ${classNameActivate}`}>
                            {children}
                        </section>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition>
    );
}
